/* jshint camelcase: false */

const { errors } = require('errors.yaml').default
const trans = require('trans')

module.exports = {
  defaultErrorMsg: errors.default_error.msg,

  /**
   * Getting error code from error msg
   * @param  {String} msg [Error message]
   * @return {Number}     [code number]
   */
  getErrorCodeFromMsg(msg) {
    if (typeof msg === 'string') {
      /**
       * [matching strings like 'html.error.78996 ...' for number after dot]
       */
      const matches = msg.match(/[a-z.]*([0-9]+)/, 'gi')
      if (matches && matches[1] && Number(matches[1]) > 0) {
        return Number(matches[1])
      } else {
        return 0
      }
    } else {
      throw new TypeError('wrong mgs provided to errorHandler.getErrorCode. Except String')
    }
  },

  /**
   * Getting error object from error code
   * @param  {Number} code [error code]
   * @param  {String} msg  [error message]
   * @return {Object}      [error object]
   */
  getErrorByCode(code, msg) {
    if (typeof code === 'number') {
      const codeArr = `${code}`.split('')
      const codeLen = codeArr.length
      let nextCodePosToReset = codeLen - 1
      let codeToCheck = code

      let err
      const error = {
        code,
        group: undefined,
        msg,
        type: undefined,
        repeate: false,
      }

      /**
       * Looping until we get proper error.msg
       *
       * To find error.mgs we will be reseting (to 0) next posiotion
       * of code in each iteration
       * example:
       *     code: 103023 will be reseting untill we find code/codeGroup
       *     with msg param in. Resetting will be as fallows:
       *     103020
       *     103000
       *     100000
       *     0
       */
      while (!error.msg && !error.type) {
        err = errors[codeToCheck]

        if (err) {
          if (!error.type) {
            error.group = codeToCheck
            error.type = err.type
            error.repeate = err.repeate !== undefined ? err.repeate : error.repeate
          }

          if (!error.msg && err.msg) {
            error.msg = trans(err.msg)
          }
        }

        /**
         * checking if nextCodePosToReset dont indicate 0
         */
        while (codeArr[nextCodePosToReset] === '0') {
          nextCodePosToReset--
        }
        codeArr[nextCodePosToReset] = 0
        codeToCheck = Number(codeArr.join(''))

        /**
         * Checking if there is no nextCodePosToReset
         */
        if (nextCodePosToReset === -1 && !error.msg) {
          error.msg = msg || errors.default_error.msg
        }

        nextCodePosToReset--
      }

      if (!error.msg) {
        error.msg = errors.default_error.msg
      }

      return error
    } else {
      throw new TypeError('wrong code provided to errorHandler.getErrorMsgByCode. Except Number')
    }
  },
}
